import dayjs from 'dayjs';

const DAYS_AFTER_WHICH_TO_DISPLAY_ABSOLUTE_DATE = 7;
export const EARLIEST_DATE = dayjs('1930-01');

export const now = () => dayjs();

/**
 * @param {Date} date - Date to calculate difference with current date.
 * @return {string} Human friendly date difference or absolute date.
 */

export function getHumanizedDateDifference(date) {
    const createdAt = dayjs(date);
    const difference = dayjs.duration(createdAt.diff(now()));

    if (Math.abs(difference.asDays()) > DAYS_AFTER_WHICH_TO_DISPLAY_ABSOLUTE_DATE) {
        return `am ${createdAt.format('DD.MM.YYYY')}`;
    }
    return difference.humanize(true);
}

export function getDateFromIsoString(date) {
    if (!date) return {};

    const [dateData] = date.split('T');
    const [year, month, day] = dateData.split('-');

    return {
        year,
        month,
        day,
    };
}
